import type { BotStateTone } from '@/lib/format'

/**
 * Единственное место, где компоненты графиков берут цвет (docs/10 §1.1:
 * «никаких сырых hex в компонентах»). SVG нельзя раскрасить tailwind-классом
 * там, где нужен `stroke`/`fill` конкретной серии, поэтому здесь возвращаются
 * ссылки на токены — `var(--chart-N)`, а не значения.
 */

/** Слоты категориальной палитры. Порядок — часть контракта (см. tokens.css). */
export const CHART_SERIES = ['1', '2', '3', '4', '5'] as const
export type ChartSeriesSlot = (typeof CHART_SERIES)[number]

/**
 * Цвет серии по её СМЫСЛУ, а не по порядку в отфильтрованном списке: фильтр,
 * убравший вторую серию, не должен перекрашивать третью.
 */
export function seriesColor(slot: ChartSeriesSlot): string {
  return `var(--chart-${slot})`
}

/** Статусный цвет — для графиков, где серия и есть состояние бота. */
export function toneColor(tone: BotStateTone): string {
  switch (tone) {
    case 'online':
      return 'var(--color-live)'
    case 'degraded':
      return 'var(--color-warn)'
    case 'connecting':
      return 'var(--color-busy)'
    case 'waiting':
      return 'var(--color-hold)'
    case 'danger':
      return 'var(--color-fail)'
    case 'offline':
      return 'var(--color-idle)'
  }
}

export const GRID_COLOR = 'var(--chart-grid)'
